export enum ContractorsRouterStateKey {
  COUNTRY = 'country',
  VAT_ID = 'vatId',
}
